import { useQuery } from 'react-query';
import { getTenantIDBasedOnURL } from 'global/tenant-config';
import { getNonBookableLaundrySlots } from './api';

// Relevant for apartment resource only
export const NON_BOOKABLE_SLOTS = 'nonBookableSlots';

export function useNonBookableSlots(resourceId) {
  const tenantId = getTenantIDBasedOnURL();

  const { data, isLoading, isFetching, isError } = useQuery(
    [NON_BOOKABLE_SLOTS, tenantId, resourceId],
    () => getNonBookableLaundrySlots(resourceId),
    {
      enabled: !!resourceId,
    },
  );

  return {
    nonBookableSlots: data?.bookings,
    isLoading,
    isFetching,
    isError,
  };
}
